export default __webpack_public_path__ + "static/media/icon-file-doc.d497e284.svg";